import { Action } from "../action";
import { Cursor } from "../cursor";
import { MarshalParameters } from "../marshal";

export class Trigger extends Action
{
    public terminating = () => true;

    constructor()
    {
        super({
            description: "Send a trigger event to automatically change state",
            parameters: {
                trigger: {
                    description: "The trigger to send",
                    type: "trigger"
                }
            }
        });
    }
    public Resolve(cursor: Cursor, parameters: MarshalParameters): boolean
    {
        cursor.trigger(parameters.trigger.value(cursor) as string);
        return true;
    }
}